import {React, useEffect, useState }from "react";
import styles from "./OrderinReview.module.css";
import { getOrderInreview } from "../../../ToolKit/Features/Review/ReviewService";
import Loader from "../../../components/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';

const ITEMS_PER_PAGE = 10;

const OrderinReview = () => {

  const dispatch = useDispatch();
  const {isLoading} = useSelector((state) => state.util);
  const reviewLists = useSelector((state) => state?.review?.reviews)
  const [reviewList, setReviewList] = useState([]);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [localLoading, setLocalLoading] = useState(true);
  const [searchInput, setSearchInput] = useState("");
  const [debounceTimeout, setDebounceTimeout] = useState(null);
   
  const handleSearchInput = (event) => {
    setSearchInput(event.target.value);
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }
    setDebounceTimeout(
      setTimeout(() => {
        //dispatch(getOrderInreviewByStatus(event.target.value));
      }, 500)
    );
  };
  
  useEffect(() => {
    const fetchData = async () => {
      await dispatch(getOrderInreview());
      setLocalLoading(false);
    };
    fetchData();
  }, [dispatch]);

  useEffect(() => {
    if (!localLoading) {
      setReviewList(reviewLists);
      setTotalPages(Math.ceil(reviewLists.length / ITEMS_PER_PAGE));
      setCurrentPage(1);
    }
  }, [localLoading, reviewLists]);

  const handlePrevClick = () => {
    setCurrentPage(currentPage - 1);
  };

  const handleNextClick = () => {
    setCurrentPage(currentPage + 1);
  };

  const startIdx = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIdx = currentPage * ITEMS_PER_PAGE;

  if (localLoading) {
    return <Loader />;
  }


  return (
    <div className={styles.userlist_container}>
      {isLoading ? (
        <Loader />
      ) : reviewList?.length === 0 ? (
        <p>Nothing to Show</p>
      ) : (
        <div>
          <h2>Procurement</h2>
          <input
            type="text"
            placeholder="Search by trackcode..."
            value={searchInput}
            onChange={handleSearchInput}
          />
           <table className={styles.user_table}>
            <thead>
              <tr>
                <th>ID</th>
                <th>Date</th>
                <th>Username</th>
                <th>Status</th>
                <th>Order Code</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {reviewList.slice(startIdx, endIdx).map((review, idx) => (
                <tr>
                  <td data-label="ID">{review?.id}</td>
                  <td data-label="Date">{review?.created}</td>
                  <td data-label="User Name">{review?.userName}</td>
                  <td data-label="Status">{review?.orderStatus}</td>
                  <td data-label="Status">{review?.trackingCodeA}</td>
                  <td
                    onClick={() => {
                      navigate(`/unit-order-review/${review?.id}`);
                    }}
                    data-label="Edit"
                  >
                    <button className={styles.edit_btn}>Manage</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {/* 
          <div className={styles.container}>
            {reviewList
              .slice(startIdx, endIdx)
              .map((review, idx) => (
                <div className={styles.tile}
                  onClick={() => {
                    navigate(`/unit-order-review/${review?.id}`);
                  }}
                  key={review?.id}
                  
                >
                  <h2 className={styles.h2}>
                    Order <span className={styles.order_id}>#{review?.id}</span>
                  </h2>
                  <p className={styles.date}>Date: {review?.orderDate}</p>
                  <p className={styles.date}>User Name: {review?.userName}</p>
                  <p className={styles.status}>Status: {review?.orderStatus}</p>
                  <p className={styles.price}>${review?.totalPrice}</p>
                </div>
              ))}
          </div>
          */}
          <div className={styles.pagination}>
            <button className={styles.page_button} onClick={handlePrevClick} disabled={currentPage === 1}>
              &#8592;
            </button>
            <span className={styles.page_number}>
              {currentPage} / {totalPages}
            </span>
            <button className={styles.page_button} onClick={handleNextClick} disabled={currentPage === totalPages}>
              &#8594;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default OrderinReview;
